import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from "react-i18next";
import { Button } from 'react-bootstrap';

import "./i18n"; 

function App() {

    const { t, i18n } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        console.log("change " + lng);
    };


    return (
      
        <div className="container" style={{ marginTop: '30px' }}>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>

                <h1>Eskuel Suite</h1>
                <div style={{ marginLeft: 'auto', marginTop: '10px' }}>
                    <Button style={{ marginLeft: '10px' }} variant="primary" onClick={() => changeLanguage("en")} >English</Button>
                    <Button style={{ marginLeft: '10px' }} variant="primary" onClick={() => changeLanguage("de")} >Deutsch</Button>
                </div>
            </div>

            <p style={{ marginBottom: 30 }}>
                {t("main_text")}
                {/*Die folgenden drei Apps helfen beim Lernen der Datenbankabfragesprache SQL.*/}
            </p>


            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', columnGap: '30px' }}>
                <div className="app-browser-card card">
                    <div className="card-header fs-4" style={{ backgroundColor: '#9BB8CD' }}>
                        <a href="./browser" style={{ color: 'black' }}>{t("browser_title")}</a>
                    </div>
                    <div className="card-body">
                        <p> 
                            {t("browser_text1")}
                           {/* Mit dem SQL-Browser kannst du aus aus einer Liste von Datenbanken auswählen oder deine eigene Datenbank hochladen. */ }
                        </p>
                        <p style={{ marginBottom: 0 }}>
                            {t("browser_text2")}
                            {/* Führe nun SQL-Abfragen aus und sieh dir die Ergebnisse an! */ }
                        </p>
                    </div>
                </div>
                <div className="app-game-console-card card">
                    <div className="card-header fs-4" style={{ backgroundColor: '#EEC759' }}>
                        <a href="./game-console" style={{ color: 'black' }}>{t("game_title")}</a>
                    </div>
                    <div className="card-body">
                        <p>
                            {t("game_text1")}
                        </p>
                        <p style={{ marginBottom: 0 }}>
                            {t("game_text2")}
                        </p>
                    </div>
                </div>
                <div className="app-game-editor-card card">
                    <div className="card-header fs-4" style={{ backgroundColor: '#B1C381' }}>
                        <a href="./game-editor" style={{ color: 'black' }}>{t("editor_title")}</a>
                    </div>
                    <div className="card-body">
                        <p>
                            {t("editor_text1")}
                        </p>
                        <p style={{ marginBottom: 0 }}>
                            {t("editor_text2")}
                        </p>
                    </div>
                </div>
            </div>

            <p style={{ marginTop: 30 }}>
                <a 
                    /*href={i18n.language === 'de' ? '/res/manual-de.pdf' : '/res/manual-en.pdf'}*/
                    href={i18n.language === 'de' ? 'https://md.infs.ch/s/pIv7H_6f_' : 'https://md.infs.ch/s/pIv7H_6f_'}
                    target="_blank">{t("user_manual")}</a> 
            </p>

        </div>
    );
}

export default App;
  
